import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom'; // Import the useNavigate hook
import { useParams } from 'react-router-dom';
// Chakra imports
import {
  Flex,
  SimpleGrid,
  Text,
  Box,
  Button,
  useColorModeValue,
  useToast,
  CircularProgress,
  FormLabel,
  Tabs,
  TabList,
  Tab,
  FormControl,
  Icon,
  Checkbox,
  useMediaQuery,
  InputGroup,
  InputLeftElement,
  IconButton,
  Input,
  InputRightElement,
  Tag,
  TagLabel,
  TagCloseButton,
} from '@chakra-ui/react';
import Select from 'react-select';
// Custom Imports
import InputField from 'components/fields/InputField';
import SelectField from 'components/fields/SelectField';
import Card from 'components/card/Card';
import OnToast from 'components/alerts/toast';
import {
  learnerListData,
  addcohorts,
  updatecohortsLearner,
  checkCohorts,
  updatecohorts,
  gamesListData,
  updatecohortsgame,
  removeassigneddata,
  removeassignedGamedata,
} from 'utils/cohorts/cohorts';
import { CiCircleCheck } from 'react-icons/ci';
import { FaCircleCheck } from 'react-icons/fa6';
import { SearchIcon, CloseIcon } from '@chakra-ui/icons';
import { IoCloseSharp, IoAddSharp, IoAddCircleSharp } from 'react-icons/io5';
import {
  updatePreviewData,
  onFocusField,
  onBlurField,
  onFieldContentModified,
} from '../../../../../store/preview/previewSlice';
import { useDispatch, useSelector } from 'react-redux';
import { Dispatch } from '@reduxjs/toolkit';
import { getCompanyList } from 'utils/creator/creator';
import { MdDelete } from 'react-icons/md';
import { elementMatches } from '@fullcalendar/core/internal';
import { GoMoveToEnd } from 'react-icons/go';

const AssignCohorts: React.FC = () => {
  const toast = useToast();
  const [isLargerThan768] = useMediaQuery('(min-width: 768px)');
  const [formData, setFormData] = useState({
    chCohortsName: '',
  });
  const dispatch: Dispatch<any> = useDispatch();

  const [gmailInput, setGmailInput] = useState<string>('');
  const [gmailList, setGmailList] = useState<string[]>([]);
  console.log(gmailList, 'gmailList');
  const [filteredLearnersGmail, setfilteredLearnersGmail] = useState<any[]>([]);
  console.log(filteredLearnersGmail, 'filteredLearnersGmail');
  const [dataLearnerToUse, setdataLearnerToUse] = useState<any[]>([]);
  console.log(dataLearnerToUse, 'dataLearnerToUse');
  const [dataToUse, setdataToUse] = useState<any[]>([]);
  const [isInputDisabled, setIsInputDisabled] = useState(false);
  const [LearnersState, setLearnersState] = useState<any>();
  const [defaultskills, setDefaultSkills] = useState<any>();
  const [gameState, setGameState] = useState<any>();
  const [isPasting, setIsPasting] = useState(false);
  const [value, setValue] = useState<String>();

  const [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState(false);
  const [typedGame, setTypedGame] = useState<any>('');

  const [msg, setMsg] = useState<string>('');
  const [toastStatus, setToastStatus] = useState<string>('');
  const navigate = useNavigate();
  const [AllLearnerList, setAllLearnerList] = useState([]);
  const [learnerFilterList, setLearnerFilterList] = useState([]);
  const [searchMail, setSearchMail] = useState([]);
  const [LearnerAssignData, setLearnerAssignData] = useState([]);
  const [cohortsId, setCohortsId] = useState<any>(null);
  const user: any = JSON.parse(localStorage.getItem('user'));
  const [selectedLearnerItems, setSelectedLearnerItems] = useState<any>([]);
  console.log(selectedLearnerItems, 'selectedLearnerItems');
  const [selectedGameItems, setSelectedGameItems] = useState<any>([]);
  const [allSelected, setAllSelected] = useState(false);
  const [allSelectedData, setAllSelectedData] = useState(false);
  const [tabState, setTabState] = useState('Assignlearner');
  const [allGames, setAllGames] = useState([]);
  const [filterGamesList, setFilterGamesList] = useState([]);
  const [searchGame, setSearchGame] = useState([]);
  const [GameAssignData, setGameAssignData] = useState([]);
  const [chortsCompanyList, setChortsCompanyList] = useState([]);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [isPopupOpenGame, setIsPopupOpenGame] = useState(false);
  const [selectedItemGame, setSelectedItemGame] = useState(null);
  const [selectedCompany, setSelectedCompany] = useState({ companyId: '' });
  const [fil, setFil] = useState<string>('');
  const [matchingGames, setMatchingGames] = useState([]);
  const [paste, setPaste] = useState(false);
  const [isCohortsNameEditable, setIsCohortsNameEditable] = useState(true);
  const searchIconColor = useColorModeValue('gray.700', 'white');
  const { id } = useParams();
  const [addI, setAddI] = useState(null);
  const { token, ...userDataWithoutToken } = user;

  let borderColor = useColorModeValue('secondaryGray.100', 'whiteAlpha.100');
  let lightBlue = useColorModeValue('#3311db5c', '#3311db5c');
  let textColor = useColorModeValue('black', 'white');

  const textareaRef = useRef<HTMLTextAreaElement | null>(null);
  const textareaRefs = useRef<HTMLTextAreaElement | null>(null);
  const textareaRefss = useRef<HTMLTextAreaElement | null>(null);

  useEffect(() => {
    if (textareaRef && textareaRef.current) {
      textareaRef.current.style.height = '0px';
      const scrollHeight = textareaRef.current.scrollHeight;
      textareaRef.current.style.height = scrollHeight + 'px';
    }
  }, []);
  useEffect(() => {
    if (textareaRefs && textareaRefs.current) {
      textareaRefs.current.style.height = '0px';
      const scrollHeight = textareaRefs.current.scrollHeight;
      textareaRefs.current.style.height = scrollHeight + 'px';
    }
  }, [value]);
  useEffect(() => {
    if (textareaRefss && textareaRefss.current) {
      textareaRefss.current.style.height = '0px';
      const scrollHeight = textareaRefss.current.scrollHeight;
      textareaRefss.current.style.height = scrollHeight + 'px';
    }
  }, [value]);

  const handleBack = () => {
    navigate('/admin/superadmin/cohort/');
  };
  const storage = JSON.parse(localStorage.getItem('user'));
  const userId = user.id;
  const userName = user.name;
  const userRole = storage?.data?.role;

  useEffect(() => {}, [tabState]);
  interface OptionTypecon {
    value: string;
    label: string;
    CompanyId: string;
  }

  const [isAddPopupOpen, setIsAddPopupOpen] = React.useState(false); // Tracks add popup state
  const [selectedLearner, setSelectedLearner] = React.useState(null); // Tracks the learner to add
  const handleAddPopupOpen = (learner: any) => {
    setSelectedLearner(learner);
    setIsAddPopupOpen(true);
  };

  const handleConfirmAdd = () => {
    if (selectedLearner) {
      handleMoveLearner(selectedLearner.lenId, selectedLearner.lenMail);
    }
    setIsAddPopupOpen(false);
    setSelectedLearner(null);
  };

  const handleCancelAdd = () => {
    setIsAddPopupOpen(false);
    setSelectedLearner(null);
  };

  const fetchData = async (getCohortsId: any) => {
    if (getCohortsId) {
      try {
        const cohortId = getCohortsId;
        const result = await checkCohorts(cohortId);
        if (result.status !== 'Success') {
          console.log('getIndustry Error', result?.message);
        } else {
          let cohorsData = result?.data;

          setFormData({
            chCohortsName: cohorsData.chCohortsName,
          });
          setSelectedCompany({
            companyId: cohorsData.chCompanyId,
          });
          setCohortsId(getCohortsId);
          setLoading(true);
          /******************** Learner Assigned Data ********************/
          if (cohorsData.learnersListAssigned.length > 0) {
            setLearnerAssignData(cohorsData.learnersListAssigned);

            let learnerAssignedIds: any[] = [];
            cohorsData.learnersListAssigned.forEach((item: any) => {
              learnerAssignedIds.push(item.lenId);
            });

            const learnerData = JSON.stringify({
              selectedCompany: cohorsData.chCompanyId,
              ...user.data,
            });
            const learnerList = await learnerListData(learnerData);
            if (learnerList.status === 'Success') {
              const learnersNotAssigned = learnerList?.data.filter(
                (item: any) => !learnerAssignedIds.includes(item.lenId),
              );
              setSelectedLearnerItems([]);
              setAllLearnerList(learnersNotAssigned);
              setLoading(false);
            }
          } else {
            setLearnerAssignData([]);
            setLoading(false);
          }

          /******************** Game Assigned Data ********************/
          if (cohorsData.gameListAssigned.length > 0) {
            setGameAssignData(cohorsData.gameListAssigned);

            let gameAssignedIds: any[] = [];
            cohorsData.gameListAssigned.forEach((item: any) => {
              gameAssignedIds.push(item.gameId);
            });

            const gameData = JSON.stringify({
              selectedCompany: cohorsData.chCompanyId,
              ...user.data,
            });
            const gamesList = await gamesListData(gameData);
            if (gamesList.status === 'Success') {
              const gamesNotAssigned = gamesList?.data.filter(
                (item: any) => !gameAssignedIds.includes(item.gameId),
              );
              setSelectedGameItems([]);
              setAllGames(gamesNotAssigned);
              setLoading(false);
            }
          } else {
            setGameAssignData([]);
            setLoading(false);
          }
        }
      } catch (error) {
        console.error('Error in fetchData:', error);
      }
    }
  };

  const updateGameState = () => {
    const updatedGames = (dataToUse || []).map((item: any) => {
      return {
        ...item,
        isSelected: selectedGameItems.includes(item.gameId),
      };
    });

    setGameState(updatedGames);
    setAllSelectedData(updatedGames.every((game: any) => game.isSelected));
  };

  useEffect(() => {
    if (id !== null) {
      fetchData(parseInt(id));
    }
  }, [id]);

  useEffect(() => {
    setAllSelected(false);
    if (id !== null) {
      fetchData(parseInt(id));
    }
  }, [id]);

  useEffect(() => {
    setAllSelected(false);
    setAllSelectedData(false);
    setSelectedLearnerItems([]);
    if (tabState === 'Assignlearner') {
      if (storage?.data?.role === 'Admin') {
        if (selectedCompany.companyId && LearnerAssignData.length === 0) {
          learnerList(selectedCompany.companyId);
        }
      } else {
        if (LearnerAssignData.length === 0) {
          learnerList();
        }
      }
    } else if (tabState === 'AssignGames') {
      if (storage?.data?.role === 'Admin') {
        if (selectedCompany.companyId && GameAssignData.length === 0) {
          gamesList(selectedCompany.companyId);
        }
      } else {
        if (GameAssignData.length === 0 && !selectedCompany.companyId) {
          gamesList();
        }
      }
    }
  }, [tabState]);
  useEffect(() => {
    if (tabState === 'Assignlearner') {
      if (searchMail.length > 0) {
        const FilterValue = AllLearnerList.filter((option) =>
          searchMail?.includes(option.lenId),
        );
        setLearnerFilterList(FilterValue);
      } else {
        setLearnerFilterList([]);
      }
    } else if (tabState === 'AssignGames') {
      if (searchGame.length > 0) {
        const FilterValue = allGames.filter((option) =>
          searchGame?.includes(option.gameId),
        );
        setFilterGamesList(FilterValue);
      } else {
        setFilterGamesList([]);
      }
    }
  }, [searchMail, searchGame]);

  const learnerList = async (selectCompany?: any) => {
    setLoading(true);
    const datas = {
      selectedCompany: selectCompany,
      ...user.data,
    };
    const data = JSON.stringify(datas);

    try {
      const AlllearnerList = await learnerListData(data);

      if (AlllearnerList.status === 'Success') {
        if (AlllearnerList?.data?.length > 0) {
          setAllLearnerList(AlllearnerList?.data);
        } else {
          setAllLearnerList([]);
        }
      } else {
        if (
          tabState === 'Assignlearner' &&
          !toast.isActive('fetch-failed-toast')
        ) {
          toast({
            title: 'No learners are found for this company!',
            position: 'bottom',
            status: 'error',
            isClosable: true,
            duration: 3000,
            id: 'fetch-failed-toast',
          });
        }
      }
    } finally {
      setLoading(false);
    }
  };

  const handleLearnerSelectedData = (id: any) => {
    setSelectedLearnerItems((prev: any) => {
      const updatedSelectedLearners = prev.includes(id)
        ? prev.filter((item: any) => item !== id)
        : [...prev, id];

      const filteredLearnerIds = filteredLearnersGmail.map(
        (item: any) => item.lenId,
      );
      setAllSelected(
        updatedSelectedLearners.length === filteredLearnerIds.length,
      );

      return updatedSelectedLearners;
    });
  };

  useEffect(() => {
    if (gmailList.length === 0 || AllLearnerList.length === 0) {
      setAllSelected(false);
    }
  }, [gmailList, AllLearnerList]);

  const handleLearnerSelectAll = () => {
    if (allSelected) {
      setSelectedLearnerItems([]);
    } else {
      const filteredLearnerIds = filteredLearnersGmail.map(
        (item: any) => item.lenId,
      );
      setSelectedLearnerItems(filteredLearnerIds);
    }

    setAllSelected(!allSelected);
  };

  const handleMoveLearner = async (id: any, gmail: string) => {
    if (!formData.chCohortsName) {
      setMsg('Please enter a Cohort Name first');
      setToastStatus('error');
      setAlert(true);
      return;
    }

    if (!selectedCompany.companyId && userRole === 'Admin') {
      setMsg('Please enter the company name');
      setToastStatus('error');
      setAlert(true);
      return;
    }

    setIsInputDisabled(true);

    const data = {
      ...userDataWithoutToken,
      chCohortsName: formData.chCohortsName,
      Admincomapany: selectedCompany?.companyId,
    };

    try {
      let cohortsResult;
      setLoading(true);

      if (cohortsId === null) {
        cohortsResult = await addcohorts(data);

        if (cohortsResult.status === 'Warning') {
          setMsg(cohortsResult.message);
          setToastStatus('error');
          setAlert(true);
          setLoading(false);
          return;
        } else if (cohortsResult.status === 'Success') {
          setCohortsId(cohortsResult.data.chId);
        }
      } else {
        cohortsResult = await updatecohorts(cohortsId, JSON.stringify(data));
        if (cohortsResult.status === 'Success') {
          setIsCohortsNameEditable(false);
          setCohortsId(cohortsResult.data.chId);
        }
      }

      if (cohortsResult.status === 'Success') {
        setIsCohortsNameEditable(false);
        const learnerToMove = dataLearnerToUse.find(
          (item: any) => item.lenId === id,
        );
        if (learnerToMove) {
          const SelectedLearnerId = [learnerToMove.lenId];

          const learnerData = {
            lenId: SelectedLearnerId,
            lenCohorts: cohortsResult.data.chId,
          };

          const result = await updatecohortsLearner(
            JSON.stringify(learnerData),
          );
          if (result.status === 'success') {
            setIsCohortsNameEditable(false);

            setSearchMail([]);
            fetchData(cohortsResult.data.chId); // Refetch data after successful learner assignment

            handleRemoveGmail(gmail); // Remove Gmail address

            // Update the learners state (unselect updated learner)
            const updatedLearners = dataLearnerToUse.map((item: any) => {
              if (item.lenId === learnerToMove.lenId) {
                return { ...item, isSelected: false }; // Unselect the updated learner
              }
              return item;
            });

            // Update the state
            setLearnersState(updatedLearners);
            setfilteredLearnersGmail(
              dataLearnerToUse.filter(
                (item) => gmailList.includes(item.lenMail.toLowerCase()), // Ensure only the remaining emails are shown
              ),
            );
            const filteredLearners = dataLearnerToUse.filter(
              (item) => gmailList.includes(item.lenMail.toLowerCase()), // Ensure only the remaining emails are shown
            );
            console.log(filteredLearners, 'filteredLearners123');
            // Recheck the "Select All" checkbox
            setAllSelected(
              updatedLearners.every((learner: any) => learner.isSelected),
            );
            setLoading(false);
          } else {
            setMsg('Failed to assign learner');
            setToastStatus('error');
            setAlert(true);
            setLoading(false);
          }
        }
      }
    } catch (error) {
      console.error('Error during learner assignment:', error);
      setMsg('An unexpected error occurred');
      setToastStatus('error');
      setAlert(true);
      setLoading(false);
    }
  };

  const handleLearnerAssign = async (gmail: any) => {
    // Validation checks
    if (!formData.chCohortsName) {
      setMsg('Please enter a Cohort Name first ');
      setToastStatus('error');
      setAlert(true);
      return false;
    }
    if (!selectedCompany.companyId && userRole === 'Admin') {
      setMsg('Please enter the company Name');
      setToastStatus('error');
      setAlert(true);
      return false;
    }
    if (selectedLearnerItems.length === 0) {
      setMsg('Please Select the Learner');
      setToastStatus('error');
      setAlert(true);
      return false;
    }

    // Data setup
    const data = {
      ...userDataWithoutToken,
      chCohortsName: formData.chCohortsName,
      Admincomapany: selectedCompany?.companyId,
    };

    setLoading(true);
    let cohortsResult;
    // If no cohortsId, create a new cohort
    if (cohortsId === null) {
      cohortsResult = await addcohorts(data);
      if (cohortsResult.status === 'Warning') {
        setMsg(cohortsResult.message);
        setToastStatus('error');
        setAlert(true);
        setLoading(false);
        return false;
      } else if (cohortsResult.status === 'Success') {
        setIsCohortsNameEditable(false);
        navigate(
          `/admin/superadmin/cohort/creation/${cohortsResult.data.chId}`,
        );
      }
    } else {
      // If cohortId exists, update the cohort
      cohortsResult = await updatecohorts(cohortsId, JSON.stringify(data));
    }

    if (cohortsResult.status === 'Success') {
      setCohortsId(cohortsResult.data.chId);

      // Get selected learner IDs based on Gmail list
      const filteredLearnerIds = filteredLearnersGmail.map(
        (item) => item.lenId,
      ); // ## Get filtered learner IDs based on filtered Gmails
      console.log(filteredLearnerIds, 'filteredLearnerIds');
      const SelectedLearnerId =
        selectedLearnerItems.length > 0
          ? selectedLearnerItems.filter((id: any) =>
              filteredLearnerIds.includes(id),
            ) // ## Use only filtered learner IDs
          : filteredLearnerIds.length > 0
          ? filteredLearnerIds
          : [];

      // Only proceed if there are selected learners
      if (SelectedLearnerId.length > 0) {
        const data = {
          lenId: SelectedLearnerId,
          lenCohorts: cohortsResult.data.chId,
        };
        const result = await updatecohortsLearner(JSON.stringify(data));

        if (result.status === 'success') {
          setIsCohortsNameEditable(false);

          setSearchMail([]); // Clear the search mail list
          setGmailList([]); // ## Clear all Gmail tags from textarea

          handleRemoveGmail(gmail); // ## Added remove logic for the selected Gmail

          // Remove only the selected Gmails from the GmailList
          const updatedGmailList = gmailList.filter(
            (email: any) => !SelectedLearnerId.includes(email),
          );

          // ## Updated logic to filter unselected Gmails and update GmailList
          setGmailList(updatedGmailList);

          // Fetch data based on the cohort ID
          fetchData(cohortsId !== null ? cohortsId : cohortsResult.data.chId);
          setLoading(false);
        }
      }
    }
  };
  const [popupItem, setPopupItem] = useState(null); // State to track the gameId for the popup

  // Function to handle add icon click
  const handleAddIconClick = (gameId: any) => {
    setPopupItem(gameId); // Set the popup item to the clicked gameId
  };

  // Function to handle confirmation in popup
  const handleConfirmAddGame = () => {
    if (popupItem) {
      handleMoveGame(popupItem); // Move the game
      setPopupItem(null); // Close the popup
    }
  };

  // Function to handle cancellation in popup
  const handleCancelAddGame = () => {
    setPopupItem(null); // Close the popup
  };

  const handleRemoveGmail = (gmailToRemove: any) => {
    setGmailList(gmailList.filter((gmail) => gmail !== gmailToRemove));
  };

  const handleTypingGame = (e: any) => {
    const value = e.target.value;
    setTypedGame(value);
  };

  const handleGameSelectedData = (id: any) => {
    setSelectedGameItems((prev: any) => {
      const updatedSelectedGames = prev.includes(id)
        ? prev.filter((item: any) => item !== id) // Deselect if already selected
        : [...prev, id]; // Select if not already selected

      const allGamesSelected =
        updatedSelectedGames.length === (dataToUse?.length || 0);
      setAllSelectedData(allGamesSelected); // Update "Select All" state
      return updatedSelectedGames;
    });
  };

  const handleMoveGame = async (id: any) => {
    // 1. Check if the cohort's name is empty
    if (!formData.chCohortsName) {
      setMsg('Please enter a Cohort Name first');
      setToastStatus('error');
      setAlert(true);
      return;
    }

    // 2. Check if a company is selected (for Admin role)
    if (!selectedCompany.companyId && userRole === 'Admin') {
      setMsg('Please select a company');
      setToastStatus('error');
      setAlert(true);
      return;
    }
    setIsInputDisabled(true);

    // 3. Prepare cohort data
    const cohortsData = {
      ...user,
      chCohortsName: formData.chCohortsName,
      Admincomapany: selectedCompany?.companyId,
    };

    try {
      let cohortsResult;

      // 4. If no cohortId exists, add a new cohort
      if (cohortsId === null) {
        cohortsResult = await addcohorts(cohortsData);

        if (cohortsResult.status === 'Warning') {
          setMsg(cohortsResult.message);
          setToastStatus('error');
          setAlert(true);
          return;
        } else if (cohortsResult.status === 'Success') {
          setCohortsId(cohortsResult.data.chId);
        }
      } else {
        // 5. If cohortId exists, update the cohort
        cohortsResult = await updatecohorts(
          cohortsId,
          JSON.stringify(cohortsData),
        );
        if (cohortsResult?.status === 'Success') {
          setCohortsId(cohortsResult?.data.chId);
        }
      }

      // 6. After successfully adding/updating the cohort, handle game assignment
      if (cohortsResult.status === 'Success') {
        setIsCohortsNameEditable(false);
        const gameToMove = dataToUse?.find((item: any) => item.gameId === id);

        if (gameToMove) {
          setLoading(true);
          const SelectedGameId = [gameToMove.gameId];

          const GameData = {
            gameId: SelectedGameId, // Add the new game ID to the list
            gameCohorts: cohortsResult.data.chId, // Use the updated cohort ID
          };

          // 7. Assign the game to the cohort
          const gameResult = await updatecohortsgame(JSON.stringify(GameData));

          if (gameResult.status === 'success') {
            fetchData(cohortsResult.data.chId); // Refetch data for the updated cohort

            // Update the game state (unselect updated game)
            const updatedGames = dataToUse.map((item: any) => {
              // Mark the moved game as not selected
              if (item.gameId === gameToMove.gameId) {
                return { ...item, isSelected: false }; // Unselect the updated game
              }
              return item;
            });

            // Update the selected game items based on updated state
            setGameState(updatedGames);
            setSelectedGameItems((prev: any) =>
              prev.filter((item: any) => item !== gameToMove.gameId),
            );

            // Recheck the "Select All" checkbox
            setAllSelectedData(
              updatedGames.every((game: any) => game.isSelected),
            );
            setLoading(false);
          } else {
            setMsg('Failed to assign game');
            setToastStatus('error');
            setAlert(true);
            setLoading(false);
          }
        }
      }
    } catch (error) {
      console.error('Error during game assignment:', error);
      setMsg('An unexpected error occurred');
      setToastStatus('error');
      setAlert(true);
    } finally {
      setIsInputDisabled(false); // Re-enable the input field after processing
    }
  };

  const handleGameSelectAll = () => {
    // ## Ensure only filtered games are handled
    const filteredGameIds =
      typedGame.length > 0
        ? (dataToUse || [])
            .filter((item: any) =>
              item.gameTitle.toLowerCase().includes(typedGame.toLowerCase()),
            )
            .map((item: any) => item.gameId)
        : (dataToUse || []).map((item: any) => item.gameId);

    const areAllGamesSelected =
      filteredGameIds.length === selectedGameItems.length;

    if (areAllGamesSelected) {
      // Deselect all filtered games
      setSelectedGameItems(
        selectedGameItems.filter(
          (item: any) => !filteredGameIds.includes(item),
        ),
      );
      setAllSelectedData(false); // Uncheck "Select All"
    } else {
      // Select filtered games
      setSelectedGameItems([
        ...new Set([...selectedGameItems, ...filteredGameIds]),
      ]);
      setAllSelectedData(true); // Check "Select All"
    }
  };

  useEffect(() => {
    const filteredLearners = AllLearnerList.filter((item, index) =>
      item?.lenUserName && item?.lenMail && fil
        ? item.lenUserName.toLowerCase().includes(fil.toLowerCase()) ||
          item.lenMail.toLowerCase().includes(fil.toLowerCase())
        : false,
    );
    const dataLearnerToUseget = fil ? filteredLearners : AllLearnerList;
    setdataLearnerToUse(dataLearnerToUseget);
  }, [AllLearnerList]);
  useEffect(() => {
    const filteredGames = allGames.filter((item, index) =>
      item?.gameTitle && fil
        ? item.gameTitle.toLowerCase().includes(fil.toLowerCase())
        : false,
    );
    const dataToUseget = fil ? filteredGames : allGames;
    setdataToUse(dataToUseget);
  }, [allGames]);
  useEffect(() => {
    if (tabState === 'Assignlearner') {
      // Reset the select all state if switching tabs
      setAllSelectedData(false);
      setSelectedGameItems([]); // Clear selected games when switching tabs
      setGameState((prev: any) =>
        (prev || []).map((game: any) => ({
          ...game,
          isSelected: false, // Ensure all games are marked as unselected
        })),
      );
    }
  }, [tabState]);

  const gamesList = async (selectCompany?: any) => {
    const datas = {
      selectedCompany: selectCompany,
      ...user.data,
    };
    const data = JSON.stringify(datas);

    try {
      const AllGamesList = await gamesListData(data);

      if (AllGamesList.status === 'Success') {
        setAllGames(AllGamesList?.data);
        // Success case: No toast message for successful fetch
      } else {
        if (
          tabState === 'AssignGames' &&
          !toast.isActive('fetch-games-failed-toast')
        ) {
          toast({
            title: 'No games are found for this company!',
            position: 'bottom', // Error shown at the bottom
            status: 'error',
            isClosable: true,
            duration: 3000, // Show for 5 seconds
            id: 'fetch-games-failed-toast', // Unique ID for this toast
          });
        }
      }
    } finally {
      setLoading(false); // Stop loading in all cases
    }
  };

  useEffect(() => {
    const fetchDataCompanyData = async () => {
      try {
        const company = await getCompanyList();
        if (company?.status !== 'Success')
          return console.log('getCountries Error :', company?.message);
        setChortsCompanyList(company?.data);
        if (storage?.data?.role === 'Admin') {
          if (selectedCompany.companyId && GameAssignData.length === 0) {
            learnerList(selectedCompany.companyId);
            gamesList(selectedCompany.companyId);
          }
        } else {
          if (GameAssignData.length === 0 && !selectedCompany.companyId) {
            gamesList();
            learnerList();
          }
        }
      } catch (error) {
        console.error('An error occurred while fetching data:', error);
      }
    };

    fetchDataCompanyData();
  }, []);

  useEffect(() => {
    const filteredLearnersGmailget = gmailList.length
      ? dataLearnerToUse.filter((item) =>
          gmailList
            .map((email) => email.toLowerCase())
            .includes(item.lenMail.toLowerCase()),
        )
      : dataLearnerToUse;
    console.log(filteredLearnersGmailget, 'filteredLearnersGmailget');

    setfilteredLearnersGmail(filteredLearnersGmailget);
  }, [gmailList, dataLearnerToUse]);

  const handleGameAssign = async () => {
    if (tabState === 'AssignGames') {
      if (!formData.chCohortsName) {
        setMsg('Please enter a Cohort Name first');
        setToastStatus('error');
        setAlert(true);
        return false;
      }
      if (selectedGameItems.length === 0) {
        setMsg('Please Select the Games');
        setToastStatus('error');
        setAlert(true);
        return false;
      }
      if (!selectedCompany.companyId && userRole === 'Admin') {
        setMsg('Please enter the company Name');
        setToastStatus('error');
        setAlert(true);
        return false;
      }

      // ## Update cohortsData and ensure gamesData handles only filtered items correctly
      const cohortsData = {
        ...user,
        chCohortsName: formData.chCohortsName,
        Admincomapany: selectedCompany?.companyId,
      };

      try {
        let cohortsResult;
        if (cohortsId === null) {
          cohortsResult = await addcohorts(cohortsData);
        } else {
          cohortsResult = await updatecohorts(
            cohortsId,
            JSON.stringify(cohortsData),
          );
        }
        setLoading(true);
        if (cohortsResult.status === 'Success') {
          setIsCohortsNameEditable(false);
          const newCohortsId = cohortsResult.data.chId;

          // ## Only send the selected games that are currently visible after filtering
          const gamesData = {
            gameId: selectedGameItems,
            gameCohorts: newCohortsId,
          };
          const gameResult = await updatecohortsgame(JSON.stringify(gamesData));
          if (gameResult.status === 'success') {
            setIsCohortsNameEditable(false);

            setAllSelected(false);
            setSearchGame([]);
            setTypedGame('');
            if (allSelectedData === true) {
              setAllSelectedData(false);
            }
            fetchData(newCohortsId);
            setLoading(false);
          } else {
            setMsg('Failed to update games');
            setToastStatus('error');
            setAlert(true);
            setLoading(false);
          }
        } else {
          setMsg('Failed to add/update cohorts');
          setToastStatus('error');
          setAlert(true);
          setLoading(false);
        }
      } catch (error) {
        console.error('Error during game assignment:', error);
        setMsg('An unexpected error occurred');
        setToastStatus('error');
        setAlert(true);
        setLoading(false);
      }
    }
  };

  /********************** For Game Function End *********************************** */

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    setFormData({ ...formData, chCohortsName: value });
  };

  const styles = {
    app: {
      display: 'flex',
      width: '100%',
      height: '100vh',
    },
    container: {
      flex: 1,
      overflowY: 'scroll' as 'scroll',
      padding: '10px',
      boxSizing: 'border-box' as 'border-box',
    },
    leftContainer: {
      backgroundColor: '#f0f0f0',
    },
    rightContainer: {
      backgroundColor: '#d0d0d0',
    },
    content: {
      height: '100%',
      maxHeight: '450px',
    },
  };

  const handleRemoveItem = async () => {
    if (selectedItem === null) return;

    // Add the deleted learner's ID to selectedLearnerItems for tracking
    setSelectedLearnerItems((prev: any) => [...prev, selectedItem]);

    try {
      const deleteStatus = await removeassigneddata(selectedItem, cohortsId);
      setLoading(true);
      // Check if the deletion was successful
      if (deleteStatus?.status === 'Success') {
        // Remove the learner from the assigned list in the state
        setLearnerAssignData((prev: any) =>
          prev.filter((item: any) => item.lenId !== selectedItem),
        );

        // Directly fetch and update cohort data again without using refreshLearnerList
        const cohortId = cohortsId;
        const result = await checkCohorts(cohortId);
        if (result.status === 'Success') {
          const cohorsData = result?.data;

          // Update the learner list based on the new cohort data
          let learnerAssignedIds: any[] = [];
          cohorsData.learnersListAssigned.forEach((item: any) => {
            learnerAssignedIds.push(item.lenId);
          });

          const learnerData = JSON.stringify({
            selectedCompany: cohorsData.chCompanyId,
            ...user.data,
          });

          // Fetch the learner list to get those not assigned
          const learnerList = await learnerListData(learnerData);
          if (learnerList.status === 'Success') {
            const learnersNotAssigned = learnerList?.data.filter(
              (item: any) => !learnerAssignedIds.includes(item.lenId),
            );

            // Update learner lists
            setAllLearnerList(learnersNotAssigned);
            setSelectedLearnerItems([]); // Clear selected items after updating
            setLoading(false);
          }
        }
      } else {
        console.log('Error:', deleteStatus?.message);
        // Optionally remove the learner ID from selectedLearnerItems if deletion fails
        setSelectedLearnerItems((prev: any) =>
          prev.filter((id: any) => id !== selectedItem),
        );
        setLoading(false);
      }
    } catch (error) {
      console.error('Error in handleRemoveItem:', error);
      setLoading(false);
    }

    // Close the pop-up after processing
    setIsPopupOpen(false);
  };

  const handleRemoveGameItem = async () => {
    // Ensure a valid selected game is present
    if (selectedItemGame === null) return;

    try {
      // Perform the delete operation for the game
      setLoading(true);
      const deleteStatus = await removeassignedGamedata(
        selectedItemGame,
        cohortsId,
      );
      // Check if the deletion was successful
      if (deleteStatus?.status === 'Success') {
        // Remove the game from the assigned list in the state
        setGameAssignData((prev: any) =>
          prev.filter((item: any) => item.gameId !== selectedItemGame),
        );

        // Refetch the updated cohort data
        const cohortId = cohortsId;
        const result = await checkCohorts(cohortId);

        // If fetching cohort data is successful, update state
        if (result.status === 'Success') {
          const cohorsData = result?.data;

          // Get assigned game IDs
          const gameAssignedIds = cohorsData.gameListAssigned.map(
            (item: any) => item.gameId,
          );

          // Prepare data for fetching all available games
          const gameData = JSON.stringify({
            selectedCompany: cohorsData.chCompanyId,
            ...user.data,
          });

          // Fetch all available games
          const gamesList = await gamesListData(gameData);
          if (gamesList.status === 'Success') {
            // Filter out already assigned games and update the state
            const gamesNotAssigned = gamesList?.data.filter(
              (item: any) => !gameAssignedIds.includes(item.gameId),
            );
            setAllGames(gamesNotAssigned);
            setSelectedGameItems([]); // Clear selected items after update
            setLoading(false);
          }
        } else {
          console.log('Error fetching cohort data:', result?.message);
          setLoading(false);
        }
      } else {
        // Handle the case where deletion fails
        console.log('Error:', deleteStatus?.message);
        setLoading(false);
      }
    } catch (error) {
      console.error('Error in handleRemoveGameItem:', error);
      setLoading(false);
    }

    // Close the popup after processing
    setIsPopupOpenGame(false);
  };

  const handlePasteGmails = (e: React.ClipboardEvent<HTMLTextAreaElement>) => {
    e.preventDefault();
    const pastedData = e.clipboardData.getData('Text');
    const emails = pastedData.split(/[\s,]+/); // Split pasted content by spaces or commas

    const validGmails = emails.filter(
      (email) => validateGmail(email) && !gmailList.includes(email),
    ); // Ensure uniqueness and validity

    setGmailList([...gmailList, ...validGmails]); // Add valid Gmail addresses to the state
    setIsPasting(true);
    // Indicate pasting has happened

    e.currentTarget.value = ''; // Clear the textarea
  };

  const SearchEmail = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    const searchemail = e.currentTarget.value.trim();
    // const getSearchmail =  AllLearnerList.filter(learner => learner.lenMail.includes(searchemail));
    const getSearchmail = AllLearnerList.filter((learner) =>
      learner.lenMail.toLowerCase().includes(searchemail.toLowerCase()),
    );
    setfilteredLearnersGmail(getSearchmail);
    //  setGmailList(getSearchmail);
    setIsPasting(true);
  };

  // Function to validate Gmail addresses
  const validateGmail = (email: string) => {
    const gmailPattern = /^[^@]+@[^@]+$/; // Ensures there is only one @ and text before/after it
    return gmailPattern.test(email);
  };

  const keyPressSkill = (e: any) => {
    if (e.keyCode === 13) {
      const trimmedValue = e.target.value.trim(); // Remove leading and trailing whitespaces

      if (trimmedValue !== '') {
        setDefaultSkills([
          ...defaultskills,
          {
            crSkillName: trimmedValue,
            crSkillId:
              defaultskills.length === 0
                ? 1
                : defaultskills[defaultskills.length - 1].crSkillId + 1,
          },
        ]);
        /*** Start - To track the changes */
        const newSkillValues = [
          ...defaultskills,
          {
            crSkillName: trimmedValue,
            crSkillId:
              defaultskills.length === 0
                ? 1
                : defaultskills[defaultskills.length - 1].crSkillId + 1,
          },
        ];
        foundValueChange(defaultskills, newSkillValues);
        /***End - To track the changes */

        setFormData((prev: any) => ({
          ...prev,
          isSkillsInvalid: false, // Include the new property in the state
        }));
      }

      e.target.value = '';
    }
  };

  const foundValueChange = async (original: any, updated: any) => {
    if (original?.length !== updated?.length) {
      triggerValueChange();
    }
  };

  const triggerValueChange = async () => {
    setTimeout(() => {
      dispatch(
        onFieldContentModified({
          gameId: id,
          modifiedField: null,
          updatedValue: null,
          isModified: true,
        }),
      );
    }, 1250);
  };

  const handleIconClick = (lenId: any) => {
    setSelectedItem(lenId);
    setIsPopupOpen(true);
  };
  const handleCancel = (popupType: string) => {
    if (popupType === 'game') {
      setIsPopupOpenGame(false);
      setSelectedItemGame(null);
    } else {
      setIsPopupOpen(false);
      setSelectedItem(null);
    }
  };
  const handleIconClickGame = (gameId: any) => {
    setSelectedItemGame(gameId);
    setIsPopupOpenGame(true);
  };
  const handleClick = async (selectCompany?: any) => {
    if (tabState === 'Assignlearner' && selectCompany) {
      learnerList(selectCompany);
    } else if (tabState === 'AssignGames' && selectCompany) {
      gamesList(selectCompany);
    }
    // setSelectedCompany()
  };

  const handleCompanyList = (selectedOption: OptionTypecon | null) => {
    setSelectedCompany({ ...selectedCompany, companyId: selectedOption.value });
    handleClick(selectedOption?.value);
  };

  const handlAddUi = (i: any) => {
    setAddI(i);
  };

  const handleClearGmails = () => {
    setGmailList([]); // Clear all Gmail tags
    setAllSelected(false);
    setfilteredLearnersGmail(dataLearnerToUse);
  };

  return (
    <>
      <Box
        display={'flex'}
        flexDirection={'column'}
        alignItems={'center'}
        marginTop={'75px'}
        position={'relative'}
      >
        <Card
          bg={'linear-gradient(to bottom, #7551ff, #3311db)'}
          w={'100%'}
          h={'300'}
          position={'absolute'}
          alignItems={'center'}
        ></Card>
        <Card
          mb={{ base: '0px', xl: '20px' }}
          width={{ base: '95%', lg: '70%' }}
          marginTop={'120px'}
        >
          <Box
            width={'100%'}
            p={2}
            display={'flex'}
            justifyContent={'center'}
            border={'2px solid #7551ff'}
            borderRadius={'20px'}
          >
            <Button
              fontSize="sm"
              borderRadius="16px"
              w={'100%'}
              h="46px"
              ms="auto"
              onClick={() => {
                setTabState('Assignlearner');
              }}
              bg={
                tabState === 'Assignlearner'
                  ? 'linear-gradient(to bottom, #7551ff, #3311db)'
                  : ''
              }
              _hover={{
                bg:
                  tabState === 'Assignlearner'
                    ? 'linear-gradient(to bottom, #7551ff, #3311db)'
                    : '',
                color: tabState === 'Assignlearner' ? 'white' : '',
              }}
              color={tabState === 'Assignlearner' ? 'white' : ''}
              _focus={{
                bg: 'linear-gradient(to bottom, #7551ff, #3311db)',
                color: 'white',
              }}
            >
              Select Learners
            </Button>
            <Button
              // variant="darkBrand"
              fontSize="sm"
              borderRadius="16px"
              w={'100%'}
              h="46px"
              ms="auto"
              _focus={{
                bg: 'linear-gradient(to bottom, #7551ff, #3311db)',
                color: 'white',
              }}
              _hover={{
                bg:
                  tabState === 'AssignGames'
                    ? 'linear-gradient(to bottom, #7551ff, #3311db)'
                    : '',
                color: tabState === 'AssignGames' ? 'white' : '',
              }}
              bg={
                tabState === 'AssignGames'
                  ? 'linear-gradient(to bottom, #7551ff, #3311db)'
                  : ''
              }
              color={tabState === 'AssignGames' ? 'white' : ''}
              onClick={() => {
                // setAllSelected(false);
                setTabState('AssignGames');
              }}
            >
              Select Games
            </Button>
          </Box>

          <Flex
            w={{ base: '100%', md: '50%' }}
            mt="10px"
            flexDirection={{ base: 'column', md: 'row' }}
            gap="30px"
          >
            <Box flex="1">
              {storage && storage?.data?.role === 'Admin' && (
                <Box flex="1">
                  <SelectField
                    mb="0px"
                    width="100%"
                    id="ctCompanyId"
                    name="companyId"
                    label="Company Name"
                    options={chortsCompanyList}
                    isClearable={true}
                    onChange={handleCompanyList}
                    value={
                      chortsCompanyList.find(
                        (option) => option.value === selectedCompany.companyId,
                      ) || null
                    }
                    isDisabled={cohortsId || id ? true : false}
                  />
                </Box>
              )}
              <InputField
                mb="0px"
                width="100%"
                name="itIndustryName"
                value={formData.chCohortsName}
                onChange={handleChange}
                // textTransform='lowercase'
                label="Cohort Name"
                // placeholder="eg. High Demand"
                placeholder="Eg. Senior Leaders"
                // onBlur={handleBlur}
                isRequired={true}
                // isReadOnly={!!id}
                isReadOnly={!isCohortsNameEditable}
                // isDisabled={isInputDisabled}
              />
            </Box>
          </Flex>

          {(storage?.data?.role === 'Creator' ||
            (selectedCompany?.companyId &&
              formData.chCohortsName &&
              storage?.data?.role === 'Admin')) && (
            <Box
              width={'100%'}
              display={'flex'}
              flexDir={{ base: 'column', md: 'row' }}
              alignItems={'flex-end'}
            >
              <FormControl width={{ base: '100%', md: '50%' }}>
                {tabState === 'Assignlearner' ? (
                  <SimpleGrid columns={{ base: 1, md: 1 }} mt={'10px'}>
                    <Box>
                      <Flex
                        direction="row"
                        p="12px"
                        wrap="wrap"
                        bg="transparent"
                        border="1px solid"
                        borderColor={borderColor}
                        borderRadius="16px"
                        _focus={{ borderColor: 'teal.300' }}
                        minH="30px"
                        maxH="300px !important"
                        h="stretch"
                        cursor="text"
                        style={{
                          overflowY: 'auto',
                          border: gmailList.length
                            ? '1px solid '
                            : '1px solid #ccc',
                        }}
                      >
                        {gmailList.map((gmail, index) => (
                          <Tag
                            fontSize="xs"
                            h="25px"
                            mb="6px"
                            me="6px"
                            borderRadius="12px"
                            variant="solid"
                            bg={lightBlue}
                            key={index}
                          >
                            <TagLabel w="100%" color={textColor}>
                              {gmail}
                            </TagLabel>
                            <TagCloseButton
                              justifySelf="flex-end"
                              color="black"
                              onClick={() => handleRemoveGmail(gmail)} // Handle removing email
                            />
                          </Tag>
                        ))}

                        <textarea
                          ref={textareaRef}
                          onPaste={handlePasteGmails} // Handle pasting Gmail addresses
                          // onKeyDown={handleTypingGmails} // Handle typing and pressing Enter

                          onChange={(e: any) => SearchEmail(e)}
                          style={gmailstyles.textareaStyle}
                          placeholder="Multi-search learner emails"
                        ></textarea>
                        {/* Conditionally render the button based on the length of gmailList */}
                        {gmailList.length > 0 && (
                          <button
                            onClick={handleClearGmails}
                            style={{
                              position: 'absolute', // Fixed position relative to the parent Box
                              top: '10px', // Adjust as needed
                              right: '10px', // Adjust as needed
                              zIndex: 1, // Ensure it's above other content
                            }}
                          >
                            Clear All
                          </button>
                        )}
                      </Flex>
                    </Box>
                  </SimpleGrid>
                ) : tabState === 'AssignGames' ? (
                  <SimpleGrid columns={{ base: 1, md: 1 }} mt={'10px'}>
                    <Box>
                      <Flex
                        direction="column"
                        p="12px"
                        bg="transparent"
                        border="1px solid"
                        borderColor="gray.300"
                        borderRadius="16px"
                        minH="30px"
                        maxH="300px !important"
                        h="stretch"
                        cursor="text"
                        style={{ overflowY: 'auto' }}
                      >
                        <textarea
                          onChange={handleTypingGame} // Update to use onChange for typing
                          value={typedGame} // Controlled input
                          style={gmailstyles.textareaStyle}
                          placeholder="Search Game name"
                        />
                      </Flex>
                    </Box>
                  </SimpleGrid>
                ) : null}

                <Box>
                  <Box width="100%">
                    <Text>
                      {' '}
                      {tabState === 'Assignlearner'
                        ? 'Select Learners'
                        : 'Select Games'}{' '}
                    </Text>

                    <div
                      style={{
                        display: 'flex', // Apply flexbox layout to the container
                        justifyContent: 'space-between', // Space out the checkbox and button
                        alignItems: 'center', // Align items vertically centered
                      }}
                    >
                      {isLargerThan768 &&
                        (tabState === 'Assignlearner' ? (
                          <Box
                            style={{
                              paddingRight:
                                allSelected || allSelectedData ? '70px' : '0', // Align items vertically centered
                              paddingTop:
                                allSelected || allSelectedData ? '20px' : '0', // Conditional padding based on selection state
                            }}
                          >
                            <Checkbox
                              id="selectAll"
                              isChecked={allSelected}
                              onChange={handleLearnerSelectAll}
                              fontSize="0.875rem"
                              fontWeight="bold"
                              color="#1b2559"
                            >
                              Select All
                            </Checkbox>
                          </Box>
                        ) : (
                          <Box
                            style={{
                              paddingTop: allSelectedData ? '20px' : '0',
                            }}
                          >
                            <Checkbox
                              id="selectAll"
                              isChecked={allSelectedData}
                              onChange={handleGameSelectAll}
                              fontSize="0.875rem"
                              fontWeight="bold"
                              color="#1b2559"
                            >
                              Select All
                            </Checkbox>
                          </Box>
                        ))}
                      {(allSelected ||
                        allSelectedData ||
                        selectedLearnerItems.length > 1 ||
                        selectedGameItems.length > 1) && (
                        <Button
                          ml="auto"
                          variant="outline" // Use 'outline' variant for a border
                          borderColor="darkBrand" // Set the border color to 'darkBrand'
                          color="darkBrand" // Set the text color to 'darkBrand'
                          fontSize="sm"
                          fontWeight="500"
                          borderRadius="70px"
                          px="24px"
                          py="5px"
                          marginTop="20px"
                          onClick={
                            tabState === 'Assignlearner'
                              ? handleLearnerAssign
                              : handleGameAssign
                          }
                        >
                          Move to
                          <Icon
                            as={GoMoveToEnd}
                            style={{
                              color: 'darkBrand', // Match the icon color with the text color
                              marginLeft: '8px', // Add some spacing between text and icon
                              width: '1.2em',
                              height: '1.2em',
                            }}
                          />
                        </Button>
                      )}
                    </div>
                  </Box>
                </Box>
              </FormControl>
              {cohortsId !== null ? (
                <Box ml={'20px'} width={{ base: '100%', md: '50%' }}>
                  <Text>
                    {tabState === 'Assignlearner'
                      ? 'Cohorts Learners'
                      : 'Games Assigned'}
                  </Text>
                </Box>
              ) : (
                <Box ml={'20px'} width={{ base: '100%', md: '50%' }}>
                  <Box
                    width="100%"
                    display="flex"
                    justifyContent="space-between"
                  >
                    <Text>
                      {tabState === 'Assignlearner'
                        ? 'Learners Assigned'
                        : 'Games Assigned'}
                    </Text>
                    {!isLargerThan768 &&
                      (tabState === 'Assignlearner' ? (
                        <Checkbox
                          id="selectAll"
                          isChecked={allSelected}
                          onChange={handleLearnerSelectAll}
                          fontSize="0.875rem"
                          fontWeight="bold"
                          color="#1b2559"
                        >
                          Select All
                        </Checkbox>
                      ) : (
                        <Checkbox
                          id="selectAll"
                          isChecked={allSelectedData}
                          onChange={handleGameSelectAll}
                          fontSize="0.875rem"
                          fontWeight="bold"
                          color="#1b2559"
                        >
                          Select All
                        </Checkbox>
                      ))}
                  </Box>
                </Box>
              )}
            </Box>
          )}
          {loading && <CircularProgress isIndeterminate color="blue.300" />}
          {tabState === 'Assignlearner' &&
          !loading &&
          ((selectedCompany?.companyId && formData.chCohortsName) ||
            (tabState === 'Assignlearner' &&
              storage?.data?.role === 'Creator')) ? (
            <SimpleGrid columns={{ base: 1, md: 2 }} pt={2}>
              <Box style={styles.container}>
                <Box style={styles.content}>
                  {filteredLearnersGmail
                    .map((item) => ({
                      ...item,
                      lenMail: item.lenMail.trim(),
                      lenUserName: item.lenUserName.trim(),
                    }))
                    .sort((a, b) => a.lenMail.localeCompare(b.lenMail))
                    .map((item, index) => (
                      <Box
                        key={index}
                        style={{
                          border: selectedLearnerItems.includes(item.lenId)
                            ? '2px solid #11047A'
                            : '2px solid #e1e1e1',
                          borderRadius: '8px',
                          cursor: 'pointer',
                          padding: '10px',
                          margin: '5px',
                          position: 'relative',
                          display: 'flex',
                          justifyContent: 'space-between',
                        }}
                        onMouseEnter={() => handlAddUi(index)}
                        onMouseLeave={() => setAddI(null)}
                        onClick={() => handleLearnerSelectedData(item.lenId)}
                      >
                        <Text>
                          {item.lenMail} / {item.lenUserName}
                        </Text>

                        {addI === index && (
                          <Icon
                            as={IoAddCircleSharp}
                            onClick={(e) => {
                              e.stopPropagation();
                              handleAddPopupOpen(item); // Open popup with learner data
                            }}
                            style={{
                              color: '#11047a',
                              cursor: 'pointer',
                              width: '1.2em',
                              height: '1.2em',
                            }}
                          />
                        )}
                      </Box>
                    ))}
                </Box>
              </Box>

              {/* Add Confirmation Popup */}
              {isAddPopupOpen && (
                <Flex
                  _before={{
                    content: '""',
                    background: '#1b1b1c4a',
                    height: '100%',
                    width: '100%',
                    position: 'fixed',
                    top: '0',
                    left: '0',
                    right: '0',
                  }}
                  position="fixed"
                  top="0"
                  left="0"
                  align="center"
                  justify="center"
                  zIndex="modal"
                  p="10px"
                >
                  <Card
                    position="fixed"
                    top="50%"
                    left="50%"
                    transform="translate(-50%, -50%)"
                    background="#fff"
                    width={{ base: '87%', sm: '87%', md: '87%', lg: '500px' }}
                    display="flex"
                    alignItems="center"
                    boxShadow="1px 2px 17px #42414556"
                    p="20px"
                  >
                    <Text display="flex" w="100%" mb="15px" textAlign="center">
                      Are you sure you want to add this learner?
                    </Text>
                    <Flex justify="center" w="100%" mt="15px">
                      <Button
                        variant="solid"
                        colorScheme="blue"
                        fontSize="sm"
                        fontWeight="500"
                        borderRadius="md"
                        px="24px"
                        py="5px"
                        onClick={handleConfirmAdd} // Confirm adding learner
                      >
                        Yes
                      </Button>
                      <Button
                        variant="outline"
                        colorScheme="gray"
                        fontSize="sm"
                        fontWeight="500"
                        borderRadius="md"
                        ml="10px"
                        onClick={handleCancelAdd} // Cancel adding learner
                      >
                        Cancel
                      </Button>
                    </Flex>
                  </Card>
                </Flex>
              )}
              <Box
                style={styles.container}
                backgroundColor="#f7f7f7"
                borderRadius="15px"
              >
                <Box style={styles.content} className="hop">
                  {LearnerAssignData.map((item, index) => (
                    <Box
                      key={index}
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        margin: '5px',
                      }}
                      role="group"
                      display={'flex'}
                      alignItems={'center'}
                    >
                      <Icon
                        as={MdDelete}
                        visibility={{ sm: 'visible', md: 'hidden' }}
                        _groupHover={{ visibility: 'visible' }}
                        style={{ marginRight: '5px', cursor: 'pointer' }}
                        onClick={() => handleIconClick(item.lenId)}
                        //  aria-label="Close"
                        tabIndex={1}
                        // onClick={() => handleRemoveItem(item.lenId)}
                      />
                      <Text>
                        {item.lenMail} / {item.lenUserName}
                      </Text>
                      {isPopupOpen && (
                        <Flex
                          _before={{
                            content: '""',
                            background: '#1b1b1c4a',
                            height: '100%',
                            width: '100%',
                            position: 'fixed',
                            top: '0',
                            left: '0',
                            right: '0',
                          }}
                          position="fixed"
                          top="0"
                          left="0"
                          align="center"
                          justify="center"
                          zIndex="modal"
                          p="10px" // Added padding to prevent edge touching
                        >
                          <Card
                            position="fixed"
                            top="50%"
                            left="50%"
                            transform="translate(-50%, -50%)"
                            background="#fff"
                            width={{
                              base: '87%',
                              sm: '87%',
                              md: '87%',
                              lg: '500px',
                            }}
                            display="flex"
                            alignItems="center"
                            boxShadow="1px 2px 17px #42414556"
                            p="20px"
                          >
                            <Text
                              display="flex"
                              w="100%"
                              mb="15px"
                              textAlign="center"
                            >
                              Are you sure to delete?
                            </Text>
                            <Flex justify="center" w="100%" mt="15px">
                              <Button
                                variant="solid"
                                colorScheme="blue"
                                fontSize="sm"
                                fontWeight="500"
                                borderRadius="md"
                                px="24px"
                                py="5px"
                                onClick={handleRemoveItem}
                              >
                                Yes
                              </Button>
                              <Button
                                variant="outline"
                                colorScheme="gray"
                                fontSize="sm"
                                fontWeight="500"
                                borderRadius="md"
                                ml="10px"
                                onClick={() => handleCancel('learner')}
                              >
                                Cancel
                              </Button>
                            </Flex>
                          </Card>
                        </Flex>
                      )}
                    </Box>
                  ))}
                </Box>
              </Box>
            </SimpleGrid>
          ) : null}

          {tabState === 'AssignGames' &&
          !loading &&
          ((selectedCompany?.companyId && formData.chCohortsName) ||
            (tabState === 'AssignGames' &&
              storage?.data?.role === 'Creator')) ? (
            <SimpleGrid columns={{ base: 1, md: 2 }} pt={2}>
              <Box style={styles.container}>
                <Box style={styles.content}>
                  {dataToUse
                    .filter((item) =>
                      item.gameTitle
                        .toLowerCase()
                        .includes(typedGame.toLowerCase()),
                    ) // Filter based on search
                    .map((item) => ({
                      ...item,
                      gameTitle: item.gameTitle.trim(),
                    }))
                    .sort((a, b) => a.gameTitle.localeCompare(b.gameTitle)) // Sort alphabetically by gameTitle
                    .map((item, index) => (
                      <Box
                        key={index}
                        style={{
                          border: selectedGameItems.includes(item.gameId)
                            ? '2px solid #11047A'
                            : '2px solid #e1e1e1',
                          borderRadius: '8px',
                          cursor: 'pointer',
                          padding: '10px',
                          margin: '5px',
                          position: 'relative',
                        }}
                        display={'flex'}
                        justifyContent={'space-between'}
                        onMouseEnter={() => handlAddUi(index)}
                        onMouseLeave={() => setAddI(null)}
                        onClick={() => handleGameSelectedData(item.gameId)} // Handle game selection
                      >
                        {item.gameTitle}

                        {addI === index && (
                          <Icon
                            as={IoAddCircleSharp}
                            onClick={(e) => {
                              e.stopPropagation();
                              handleAddIconClick(item.gameId); // Open popup on add icon click
                            }}
                            style={{
                              color: '#11047a',
                              cursor: 'pointer',
                              width: '1.2em',
                              height: '1.2em',
                            }}
                          />
                        )}
                      </Box>
                    ))}

                  {popupItem && ( // Show popup if popupItem is set
                    <Flex
                      _before={{
                        content: '""',
                        background: '#1b1b1c4a',
                        height: '100%',
                        width: '100%',
                        position: 'fixed',
                        top: '0',
                        left: '0',
                        right: '0',
                      }}
                      position="fixed"
                      top="0"
                      left="0"
                      align="center"
                      justify="center"
                      zIndex="modal"
                      p="10px"
                    >
                      <Card
                        position="fixed"
                        top="50%"
                        left="50%"
                        transform="translate(-50%, -50%)"
                        background="#fff"
                        width={{
                          base: '87%',
                          sm: '87%',
                          md: '87%',
                          lg: '500px',
                        }}
                        display="flex"
                        alignItems="center"
                        boxShadow="1px 2px 17px #42414556"
                        p="20px"
                      >
                        <Text
                          display="flex"
                          w="100%"
                          mb="15px"
                          textAlign="center"
                        >
                          Are you sure you want to add this game?
                        </Text>
                        <Flex justify="center" w="100%" mt="15px">
                          <Button
                            variant="solid"
                            colorScheme="blue"
                            fontSize="sm"
                            fontWeight="500"
                            borderRadius="md"
                            px="24px"
                            py="5px"
                            onClick={handleConfirmAddGame} // Confirm action
                          >
                            Yes
                          </Button>
                          <Button
                            variant="outline"
                            colorScheme="gray"
                            fontSize="sm"
                            fontWeight="500"
                            borderRadius="md"
                            ml="10px"
                            onClick={handleCancelAddGame} // Cancel action
                          >
                            Cancel
                          </Button>
                        </Flex>
                      </Card>
                    </Flex>
                  )}
                </Box>
              </Box>

              <Box
                style={styles.container}
                backgroundColor="#f7f7f7"
                borderRadius="15px"
              >
                <Box style={styles.content}>
                  {GameAssignData.map((item, index) => (
                    <Box
                      key={index}
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        margin: '5px',
                      }}
                      role="group"
                    >
                      <Icon
                        as={MdDelete}
                        visibility={{ sm: 'visible', md: 'hidden' }}
                        _groupHover={{ visibility: 'visible' }}
                        style={{ marginRight: '5px', cursor: 'pointer' }}
                        onClick={() => handleIconClickGame(item.gameId)}
                        //  aria-label="Close"
                        tabIndex={1}
                        // onClick={() => handleRemoveItem(item.lenId)}
                      />
                      {item.gameTitle}

                      {isPopupOpenGame && ( // Show popup for the correct gameId
                        <Flex
                          _before={{
                            content: '""',
                            background: '#1b1b1c4a',
                            height: '100%',
                            width: '100%',
                            position: 'fixed',
                            top: '0',
                            left: '0',
                            right: '0',
                          }}
                          position="fixed"
                          top="0"
                          left="0"
                          align="center"
                          justify="center"
                          zIndex="modal"
                          p="10px"
                        >
                          <Card
                            position="fixed"
                            top="50%"
                            left="50%"
                            transform="translate(-50%, -50%)"
                            background="#fff"
                            width={{
                              base: '87%',
                              sm: '87%',
                              md: '87%',
                              lg: '500px',
                            }}
                            display="flex"
                            alignItems="center"
                            boxShadow="1px 2px 17px #42414556"
                            p="20px"
                          >
                            <Text
                              display="flex"
                              w="100%"
                              mb="15px"
                              textAlign="center"
                            >
                              Are you sure you want to delete this game?
                            </Text>
                            <Flex justify="center" w="100%" mt="15px">
                              <Button
                                variant="solid"
                                colorScheme="blue"
                                fontSize="sm"
                                fontWeight="500"
                                borderRadius="md"
                                px="24px"
                                py="5px"
                                onClick={handleRemoveGameItem} // Trigger game removal
                              >
                                Yes
                              </Button>
                              <Button
                                variant="outline"
                                colorScheme="gray"
                                fontSize="sm"
                                fontWeight="500"
                                borderRadius="md"
                                ml="10px"
                                onClick={() => handleCancel('game')} // Cancel action
                              >
                                Cancel
                              </Button>
                            </Flex>
                          </Card>
                        </Flex>
                      )}
                    </Box>
                  ))}
                </Box>
              </Box>
            </SimpleGrid>
          ) : null}

          <Flex justify="space-between">
            <Button
              variant="light"
              fontSize="sm"
              borderRadius="16px"
              w={'100%'}
              h="46px"
              mt="20px"
              onClick={handleBack}
            >
              Back
            </Button>
          </Flex>
        </Card>
      </Box>
      {alert ? (
        <OnToast msg={msg} status={toastStatus} setAlert={setAlert} />
      ) : null}
    </>
  );
};

export default AssignCohorts;

const gmailstyles: { [name: string]: React.CSSProperties } = {
  container: {
    marginTop: 50,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  textareaDefaultStyle: {
    padding: 5,
    width: '100%',
    display: 'block',
    resize: 'none',
    backgroundColor: 'white',
    borderRadius: '12px',
    borderColor: '#E0E5F2', // Border color
    outlineColor: '#E0E5F2', // Outline color
    borderWidth: '1px', // Border width
    borderStyle: 'solid', // Border style
    overflow: 'auto', // Hide the scrollbar
    fontSize: '0.875rem',
    fontWeight: 500,
    color: '#1b2559',
  },
  textareaStyle: {
    padding: 2,
    width: '100%',
    // marginLeft:'10px',
    display: 'block',
    resize: 'none',
    backgroundColor: 'white',
    borderRadius: '12px',
    borderColor: 'white', // Border color
    outlineColor: 'white', // Outline color
    borderWidth: '1px', // Border width
    borderStyle: 'solid', // Border style
    overflow: 'hidden',
  },
  labelStyle: {
    display: 'block',
    fontSize: 'smaller',
    fontWeight: 'bold',
    marginBottom: '5px', // Add margin to separate label and textarea
    marginRight: '430px',
  },
  labelLearningStyle: {
    display: 'block',
    fontSize: 'smaller',
    fontWeight: 'bold',
    marginBottom: '5px', // Add margin to separate label and textarea
    marginRight: '370px',
  },
};
